import { ApiCatch } from "@/utils/decorators";
import { InvoiceInfoDTO } from "~/dal/invoice.info.dto";
import { InvoiceServicesDTO } from "~/dal/invoice.services.dto";
import { PayDetailDTO } from "~/dal/pay.detail.dto";
import { PaysInfoDTO } from "~/dal/pays.info.dto";
import { ServiceInfoDTO } from "~/dal/service.info.dto";
import { Api } from "../api.service";

export class DalService {
  @ApiCatch
  static async getAccounts() {
    const response = await Api.get("/dal/accounts");
    return response.data;
  }

  @ApiCatch
  static async getCounterCheckInfo(Account_id: number, Lang: string) {
    const response = await Api.get("/dal/checkinfo", {
      params: {
        Account_id: Account_id,
        Lang: Lang,
      },
    });
    return response.data;
  }

  @ApiCatch
  static async getLastPayDate() {
    const response = await Api.get("/dal/getLastPayDate");
    return response.data;
  }

  @ApiCatch
  static async getServiceInfo(req: ServiceInfoDTO) {
    const response = await Api.post("/dal/getServiceInfo", req);
    return response.data;
  }

  @ApiCatch
  static async getReceiptInfo(req: PaysInfoDTO) {
    const response = await Api.post("/dal/getReceiptInfo", req);
    return response.data;
  }

  @ApiCatch
  static async getReceiptDetails(req: PayDetailDTO) {
    const response = await Api.post("/dal/getReceiptDetails", req);
    return response.data;
  }

  @ApiCatch
  static async getAccountInvoices(req: InvoiceInfoDTO) {
    const response = await Api.post("/dal/getAccountInvoices", req);
    return response.data;
  }

  @ApiCatch
  static async getInvoiceServices(req: InvoiceServicesDTO) {
    const response = await Api.post("/dal/getInvoiceServices", req);
    return response.data;
  }

  @ApiCatch
  static async getCntCheckInfo(Account_id: number) {
    const response = await Api.get("/dal/getCntCheckInfo", {
      params: {
        Account_id: Account_id,
      },
    });
    return response.data;
  }

  @ApiCatch
  static async getInvoicePrinted(
    AccountId: number,
    BillId: number,
    year: number,
    month: number,
  ) {
    const response = await Api.get("/dal/getInvoicePrinted", {
      params: {
        AccountId: AccountId,
        BillId: BillId,
        year: year,
        month: month,
      },
    });
    return response.data;
  }

  @ApiCatch
  static async getLinkForOnline() {
    const response = await Api.get("/dal/getLinkForOnline");
    return response.data;
  }

  @ApiCatch
  static async deleteAccount(req: any) {
    const response = await Api.get("/dal/deleteAccount", {
      params: {
        ...req,
      },
    });
    return response.data;
  }

  @ApiCatch
  static async addNewAccount(req: any) {
    const response = await Api.get("/dal/addNewAccount", {
      params: {
        ...req,
      },
    });
    return response.data;
  }

  @ApiCatch
  static async changePassword(req: any) {
    const response = await Api.post("/auth/changePassword", req);
    return response.data;
  }

  @ApiCatch
  static async updatePersonalData(req: any) {
    const response = await Api.post("/dal/updatePersonalData", req);
    return response.data;
  }

  @ApiCatch
  static async isExistEmail(req: any) {
    const response = await Api.post("/dal/isExistEmail", req);
    return response.data;
  }

  @ApiCatch
  static async registration(req: any) {
    const { recaptchaToken, ...body } = req;
    const response = await Api.post("/auth/registration", body, {
      params: { recaptchaToken },
    });
    return response.data;
  }
}
